module.exports = __webpack_public_path__ + "img/icon3.aee34a61.svg";